import { map, pipe, prop } from 'ramda';
import { useEffect, useState } from 'react';
import { GET_LIST, useDataProvider, useVersion } from 'react-admin';

const useInteractionTypeGroups = (active = true) => {
  const [groups, setGroups] = useState([]);
  const version = useVersion();
  const dataProvider = useDataProvider();

  const filters = {
    specificFields: [
      'nodeId',
      'id',
      'name',
      'types',
      'active',
      'interactionTypeId'
    ],
    active
  };

  const fetchTypeGroups = async () => {
    const { data } = await dataProvider(GET_LIST, 'InteractionTypeGroup', {
      filter: filters,
      pagination: { page: 1, perPage: 2000 }
    });

    const mappedGroups = pipe(
      map((group) => ({
        id: prop('originalId', group),
        nodeId: prop('nodeId', group),
        name: prop('name', group),
        types: prop('types', group)
      }))
    )(data);

    setGroups(mappedGroups);
  };

  useEffect(() => {
    fetchTypeGroups();
  }, [version]);

  return {
    groups
  };
};

export default useInteractionTypeGroups;
